import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl =  endpointNames.manager;
const url = 'https://mynhaka-api.herokuapp.com/api'

// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));


//get all managers
const getAllManagers = async() => {
        let response;
        const config = {
            headers: {Authorization: `Bearer ${token}`}
        };
        await axios.get(baseUrl+'s', config)
            .then(res => {
                console.log(res);
                response = res;
            })
            .catch(err => {
                console.log(err);
                response = err;
            });
        return response;
}






//get manager details
const getManagerDetails = async(id) => {
    let response;
    await axios.get(baseUrl + '/' + id, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res.data;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}



//add manager
const addManager = async(request) => {
    let response;


    const data = {
        'name': request.name,
        'surname': request.surname,
        'email': request.email,
        'branch': request.branch,
        'contact_number': request.contact_number
    };

    await axios.post(baseUrl,data,  {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}




//update managers
const updateManager = async(request) => {
    let response;
    await axios.put(baseUrl + '/update/' + request.managerId, {
        'name': request.name,
        'surname': request.surname,
        'email': request.email,
        'branch': request.branch,
        'contact_number': request.contact_number
    }, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//delete manager
const deleteManager = async(id) => {
    let response;
    await axios.delete(baseUrl+'manager/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}


async function activate(id){

    console.log("id: ", id)
    try{
        const response = await axios.post(baseUrl + '/activate/' + id,{}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        console.log("response:", response);
        return response;
    }catch (e) {
        console.log(e);
        return 0;
      }
}

async function deactivate(id){
    console.log("id: ", id)

    console.log("id: ", id)
    try{
        const response = await axios.post(baseUrl + '/de-activate/' + id,{}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        console.log("response:", response);
        return response;
    }catch (e) {
        console.log(e);
        return 0;
      }
}

export default {
    getAllManagers,getManagerDetails,addManager,updateManager,deleteManager, activate, deactivate
}
